import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import Radium from 'radium';
import Input from '../UIKit/Input';

class JumperFormsyInput extends React.Component {
  showError() {
    const { isPristine, isValid } = this.props;

    if (isPristine()) {
      return false;
    }

    return !isValid();
  }

  getPropsForState() {
    const { showRequired } = this.props;

    return {
      error: this.showError(),
      showRequired: showRequired(),
    };
  }

  extractInputProps() {
    const {
      setValidations,
      setValue,
      resetValue,
      getValue,
      hasValue,
      getErrorMessage,
      getErrorMessages,
      isFormDisabled,
      isValid,
      isPristine,
      isFormSubmitted,
      isRequired,
      showRequired,
      showError,
      isValidValue,
      validationError,
      validationErrors,
      value,
      innerRef,
      ...inputProps
    } = this.props;

    return inputProps;
  }

  render() {
    const { getValue, setValue, style } = this.props;
    const inputProps = this.extractInputProps();
    const validationProps = this.getPropsForState();
    return (
      <Input
        value={getValue()}
        onChange={e => setValue(e.target.value)}
        {...inputProps}
        {...validationProps}
        style={style}
      />
    );
  }
}

JumperFormsyInput.propTypes = {
  style: PropTypes.object,
};

JumperFormsyInput.defaultProps = {
  className: '',
  style: {},
};

export default withFormsy(Radium(JumperFormsyInput));



// WEBPACK FOOTER //
// ./src/components/Formsy/Input.js